// Sizes the self-sizing boxes (textarea.autoresize) under each root to what they hold.
//
// The custom form page sizes every one of these boxes as it loads
// (shared/form/_custom_form_new and _custom_form_edit). A box out of sight
// then measures nothing and is pinned at no height, so it shows as a thin
// sliver once it comes into view: a comment in a discharge goal row that
// starts closed, a visit note goal added to the session later, a goal hidden
// with Customize Goals Shown. The Goals v3 rows call this as they show their
// boxes. A box still out of sight is left as it is, to be sized when it shows.
export default function fitAutoresizeTextareas(...roots) {
  const boxes = [...new Set(roots.flatMap((root) => [...root.querySelectorAll('textarea.autoresize')]))];
  const heights = boxes.map((box) => box.style.height);
  boxes.forEach((box) => {
    box.style.height = 'auto';
  });
  // Every box is measured before any is sized, so the page lays out once
  // rather than once for each box.
  const fits = boxes.map((box) => box.scrollHeight);
  boxes.forEach((box, index) => {
    box.style.height = fits[index] > 0 ? `${fits[index]}px` : heights[index];
  });
}
